// extracted by mini-css-extract-plugin
module.exports = {"Globe":"styles_Globe__2TkWD","OnReady":"styles_OnReady__2o5KS","fadeIn":"styles_fadeIn__1nvD0"};